import mirrorCreator from 'mirror-creator';

export * from './actionTypes';
export * from './menu';
export const AlertMessageTypes = mirrorCreator(['danger', 'success', 'warning']);
export const DROPDOWN_SEARCH_MINIMUM = 7;
export const TYPE_TEXT = 'text';
